export function getHistoryTime(file) {
  for (const value of [file?.shooting_date, file?.uploaded_at]) {
    if (!value) continue;
    const parsed = new Date(value).getTime();
    if (Number.isFinite(parsed)) return parsed;
    const parts = String(value).match(/(\d{4})\D+(\d{1,2})\D+(\d{1,2})/);
    if (parts) return new Date(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3])).getTime();
  }
  return null;
}

export function getHistoryRelation(file, currentFile) {
  if (file.upload_id === currentFile.upload_id) return "current";
  const time = getHistoryTime(file), current = getHistoryTime(currentFile);
  if (time == null || current == null) return "unknownDate";
  return time < current ? "before" : time > current ? "after" : "sameDate";
}
